export const strings = {
  NAME: "Divider",
  DESCRIPTION: "A separator between your content.",
  SPACING_FIELD_LABEL: "Spacing",
  WIDTH_FIELD_LABEL: "Width",
} as const;
